import React from 'react';
import { ProgressStepper } from 'web-ui-components/lib/navigation/indicators';
import { ShellPanel } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NTB_JOURNEY } from 'constants/general';
import { existingJourneySteps, ntbJourneySteps } from 'utils/progressSteps';

export const ProgressSteps = ({ currentStepId, journey }) => {
  return (
    <ShellPanel>
      <StandardBody>
        <ProgressStepper
          currentStepId={currentStepId}
          items={journey === NTB_JOURNEY ? ntbJourneySteps : existingJourneySteps}
        />
      </StandardBody>
    </ShellPanel>
  );
};
